<nav class="navbar" [ngClass]="{'bg-dark': theme() === 'dark'}">
  <ul class="navbar__content">
    <ng-container *appHasPermission="'fornecedor>cadastro>finalizar-cadastro'">
      <div class="d-flex w-100 justify-content-center align-items-start spacer">
        <img
          [src]="'assets/instances-config/' + instanceName + '/layout/visual-identity/images/navbar-brand.png'"
          style="width: 200px"
          alt=""
        />
      </div>
    </ng-container>

    <ul class="spacer h-100 d-flex">
      <ng-container *appHasNotPermission="'fornecedor>cadastro>finalizar-cadastro'">
        <navbar-clickable-container
          class="navbar-clickable-container me-2"
          mat-button
          disableRipple
          (click)="toggleMenuCollapse()"
        >
          <i class="bi bi-layout-sidebar fs-4" [ngClass]="{'text-white': theme() === 'dark'}"> </i>
        </navbar-clickable-container>

        <ng-container>
          <div class="h-100 d-flex align-items-center">
            <button hidden
              #registersMenu="cdkOverlayOrigin"
              cdkOverlayOrigin
              (click)="menuAddShortcutsOpen = !menuAddShortcutsOpen"
              mat-stroked-button
              disableRipple
              class="rounded-pill"
              [ngClass]="{
                  'text-white': theme() === 'dark',
                }"
            >
              <i class="bi bi-plus-lg text-normal"></i>
              Adicionar
              <i class="bi bi-caret-down-fill p10"></i>
            </button>
          </div>

          <eretail-menu-wrapper
            [trigger]="registersMenu"
            [menuOpen]="menuAddShortcutsOpen"
            (closeMenu)="menuAddShortcutsOpen = false"
            [positions]="[
                {
                  originX: 'start',
                  originY: 'bottom',
                  overlayX: 'start',
                  overlayY: 'top',
                },
              ]"
          >
            <div class="navbar-menu-item" routerLink="Produtos/pre-ficha/cadastrar" item-close-menu>
              <i class="bi bi-cart fs-4" matBadge="+" matBadgeSize="medium" matBadgeDescription="adicionar"></i>
              <span class="ms-3 fs-5">Produto</span>
            </div>

            <div class="navbar-menu-item" routerLink="cadastros/novo-usuario" item-close-menu>
              <i class="bi bi-person fs-4" matBadge="+" matBadgeSize="medium" matBadgeDescription="adicionar"></i>
              <span class="ms-3 fs-5">Usuário</span>
            </div>

            <div class="navbar-menu-item" routerLink="cadastros/novo-perfil" item-close-menu>
              <i class="bi bi-person-badge fs-4" matBadge="+" matBadgeSize="medium" matBadgeDescription="adicionar"></i>
              <span class="ms-3 fs-5">Perfil</span>
            </div>
          </eretail-menu-wrapper>
        </ng-container>
      </ng-container>
    </ul>

    <small class="w-full d-flex justify-content-center"> Versão {{ sysVersion || '1.0.1' }} </small>

    <ng-container *appHasNotPermission="'fornecedor>cadastro>finalizar-cadastro'">
      <li class="navbar-navigation flex-fill">
        <breadcrumbs class="breadcrumbs"></breadcrumbs>
      </li>
    </ng-container>

    <ul class="d-flex h-100">
      <ng-container *appHasNotPermission="'fornecedor>cadastro>finalizar-cadastro'">
        <button
          #reportsMenu="cdkOverlayOrigin"
          cdkOverlayOrigin
          class="navbar-clickable-container report-menu rounded-0 px-4"
          mat-button
          disableRipple
          (click)="menuReportOpen = !menuReportOpen"
          [ngClass]="{
              'text-white': theme() === 'dark',
            }"
        >
          <i class="bi bi-file-earmark-text text-normal"></i>
          Relatórios
          <i class="bi bi-caret-down-fill p10"></i>
        </button>
        <eretail-menu-wrapper [trigger]="reportsMenu" [menuOpen]="menuReportOpen" (closeMenu)="menuReportOpen = false">
          <div class="navbar-menu-item" (click)="openExtractReportDialog()">
            <i class="bi bi-file-earmark-text fs-4" matBadge="+"></i>
            <span class="ms-3 fs-5">Gerar Novo Relatório</span>
          </div>

          <div class="navbar-menu-item" (click)="openAddScheduledReportDialog()">
            <i class="bi bi-calendar-date fs-4" matBadge="+"></i>
            <span class="ms-3 fs-5">Agendar Relatório</span>
          </div>

          <div class="navbar-menu-item" routerLink="relatorios/agendamentos" item-close-menu>
            <i class="bi bi-calendar-event fs-4"></i>
            <span class="ms-3 fs-5">Agendamentos</span>
          </div>
        </eretail-menu-wrapper>
      </ng-container>

      <!-- <navbar-clickable-container class="navbar-clickable-container" (click)="toggleThemeMode()">
          <i
            class="btn-expand bi bi-moon text-normal"
            [ngClass]="{
              'bi bi-moon': theme() === 'light', 
              'bi bi-brightness-high text-white': theme() === 'dark', 
            }"
          >
          </i>
        </navbar-clickable-container> -->

      <!-- <navbar-clickable-container [cdkMenuTriggerFor]="notificationMenu" class="navbar-clickable-container">
          <i
            class="bi bi-bell text-normal"
            matBadge="5"
            matBadgeSize="small"
            matBadgeColor="warn"
            [ngClass]="{
              'text-white': theme() === 'dark',
            }"
          ></i>
        </navbar-clickable-container> -->

      <!-- <navbar-clickable-container class="navbar-clickable-container__enterprise-icon ms-2"> -->
      <!-- <mat-card class="navbar-clickable-container-wrapper">
            <img mat-card-avatar class="m-0 navbar-user-icon" src="assets/images/SuaFarma-mini.png" />
          </mat-card> -->
      <!-- </navbar-clickable-container> -->

      <navbar-clickable-container
        #profileMenu="cdkOverlayOrigin"
        cdkOverlayOrigin
        (click)="menuProfileOpen = !menuProfileOpen"
        class="navbar-clickable-container"
      >
        <mat-card class="navbar-clickable-container-wrapper">
          <img mat-card-avatar class="m-0 me-1 navbar-user-icon" src="assets/images/userExampleIcon.png" />

          <i
            class="bi bi-caret-down-fill p10"
            [ngClass]="{
              'text-white': theme() === 'dark',
            }"
          ></i>
        </mat-card>
      </navbar-clickable-container>
    </ul>
  </ul>
</nav>

<eretail-menu-wrapper
  [trigger]="profileMenu"
  [menuOpen]="menuProfileOpen"
  (closeMenu)="menuProfileOpen = false"
  item-close-menu
>
  <ng-container *appHasNotPermission="'fornecedor>cadastro>finalizar-cadastro'">
    <div class="navbar-menu-item" routerLink="/dashboard" routerLink="config" item-close-menu>
      <div class="d-flex align-items-center flex-fill">
        <img mat-card-avatar class="m-0 avatar" src="assets/images/userExampleIcon.png" />
        @if (currentUser()) {
        <div class="ms-3 d-flex flex-column">
          <span class="fs-5 fw-light"> {{ currentUser().nome }} </span>
          @if (currentUser().perfil && currentUser().perfil.nome) {
          <small class="text-default">{{ currentUser().perfil.nome }}</small>
          }
        </div>
        }
      </div>

      <i class="bi bi-pencil fs-5"></i>
    </div>
    <hr />

    <div class="navbar-menu-item" routerLink="config" item-close-menu>
      <i class="bi bi-gear fs-3"></i>
      <span class="ms-3 fs-5">Configurações</span>
    </div>

    <div class="navbar-menu-item" (click)="openPasswordDialog()" item-close-menu>
      <i class="bi bi-gear fs-3"></i>
      <span class="ms-3 fs-5">Alterar senha</span>
    </div>
  </ng-container>

  <div class="navbar-menu-item" (click)="this.logOut()">
    <i class="bi bi-box-arrow-right fs-3"></i>
    <span class="ms-3 fs-5">Sair</span>
  </div>

  <hr/>

  <small class="w-full d-flex justify-content-center"> Versão {{ sysVersion || '1.0.1' }} </small>
</eretail-menu-wrapper>

<ng-template #notificationMenu>
  <div class="d-flex flex-column notification-menu__wrapper">
    <div class="triangle align-self-end"></div>

    <div class="notification-title__container bg-white">
      <span class="ms-3 text-secondary">Notificações Recentes</span>
    </div>

    <mat-card class="navbar-menu notification-menu pb-0" cdkMenu>
      <hr class="p-0 m-0" />

      <div
        class="navbar-menu-item notification-menu-item flex-column align-items-start pt-2 pb-4"
        routerLink="cadastros/novo-usuario"
      >
        <span class="p-12 text-black bolder">Oferta de Produtos</span>
        <p class="text-black fw-light">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua.
        </p>
      </div>
      <hr class="p-0 m-0" />

      <div
        class="navbar-menu-item notification-menu-item flex-column align-items-start pt-2 pb-4"
        routerLink="cadastros/novo-usuario"
      >
        <span class="p-12 text-black bold">Solicitação de Fornecedor</span>
        <p class="text-black fw-light">
          Um fornecedor está esperando pela sua aprovação para prosseguir. Acesse agora para revisar os detalhes e tomar
          a ação necessária.
        </p>
      </div>
      <hr class="p-0 m-0" />

      <div
        class="navbar-menu-item notification-menu-item flex-column align-items-start pt-2 pb-4"
        routerLink="cadastros/novo-usuario"
      >
        <span class="p-12 text-black bold">Alerta de estoque baixo </span>
        <p class="text-black fw-light">
          Alguns itens estão com estoque crítico. Reabasteça o quanto antes para evitar falta de produtos.
        </p>
      </div>
      <hr class="p-0 m-0" />

      <div
        class="navbar-menu-item notification-menu-item flex-column align-items-start pt-2 pb-4"
        routerLink="cadastros/novo-usuario"
      >
        <span class="p-12 text-black bold">Novo Pedido Recebido</span>
        <p class="text-black fw-light">
          Verifique e processe o pedido de medicamentos para garantir a disponibilidade.
        </p>
      </div>
      <hr class="p-0 m-0" />

      <div
        class="navbar-menu-item notification-menu-item flex-column align-items-start pt-2 pb-4"
        routerLink="cadastros/novo-usuario"
      >
        <span class="p-12 text-black bold">Solicitação de Fornecedor</span>
        <p class="text-black fw-light">
          Um fornecedor está esperando pela sua aprovação para prosseguir. Acesse agora para revisar os detalhes e tomar
          a ação necessária.
        </p>
      </div>
    </mat-card>

    <navbar-clickable-container class="bg-white p-2 notification-menu-item__seeAll-option">
      Ver Tudo
    </navbar-clickable-container>
  </div>
</ng-template>
